import React, { useState } from "react";
import { Image, Button, Icon, Confirm, Popup } from "semantic-ui-react";
import { image } from "../../../../assets";
import { User } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { BasicModal, CanUpdate, CanDelete } from "../../../Shared";
import { ENV } from "../../../../utils";
import { UserForm } from "../UserForm";
import "./UserItem.scss";

const userController = new User();

export function UserItem(props) {
  const { user, onReload } = props;
  const { accessToken } = useAuth();

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [isDelete, setIsDelete] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openUpdateUser = () => {
    setTitleModal(`¿Actualizar ${user.email}?`);
    onOpenCloseModal();
  };

  const openActivateDesactivateConfirm = () => {
    setIsDelete(false);
    setConfirmMessage(
      user.active
        ? `¿Desactivar usuario ${user.email}?`
        : `¿Activar usuario ${user.email}?`
    );
    onOpenCloseConfirm();
  };

  const onActivateDesactivate = async () => {
    try {
      await userController.updateUser(user.id, {
        active: !user.active,
      });
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  const openDeleteConfirm = () => {
    setIsDelete(true);
    setConfirmMessage(`¿Eliminar usuario ${user.email}?`);
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      await userController.deleteUser(user.id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="user-item">
        <div className="user-item__info">
          <Image
            avatar
            src={
              user.avatar ? `${ENV.BASE_PATH}/${user.avatar}` : image.noAvatar
            }
          />
          <div>
            <p>
              {user.firstname} {user.lastname}
            </p>
            <p>{user.email}</p>
          </div>
        </div>
        <div>
          {/* Botón editar - solo visible con permiso user.update */}
          <CanUpdate module="user">
            <Popup
              content="Actualizar usuario"
              trigger={
                <Button icon primary onClick={openUpdateUser}>
                  <Icon name="pencil" />
                </Button>
              }
            />
          </CanUpdate>
          {/* Botón activar/desactivar - solo visible con permiso user.update */}
          <CanUpdate module="user">
            <Popup
              content={`${user.active ? "Desactivar" : "Activar"} usuario`}
              trigger={
                <Button
                  icon
                  color={user.active ? "orange" : "teal"}
                  onClick={openActivateDesactivateConfirm}
                >
                  <Icon name={user.active ? "ban" : "check"} />
                </Button>
              }
            />
          </CanUpdate>
          {/* Botón eliminar - solo visible con permiso user.delete */}
          <CanDelete module="user">
            <Popup
              content="Eliminar usuario"
              trigger={
                <Button icon color="red" onClick={openDeleteConfirm}>
                  <Icon name="trash" />
                </Button>
              }
            />
          </CanDelete>
        </div>
      </div>
      <BasicModal show={showModal} close={onOpenCloseModal} title={titleModal}>
        <UserForm close={onOpenCloseModal} onReload={onReload} user={user} />
      </BasicModal>
      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={isDelete ? onDelete : onActivateDesactivate}
        content={confirmMessage}
        size="mini"
      />
    </>
  );
}
